(() => {
  function initCozyTreeHeader(header) {
    if (!header) return;
    if (header.dataset.ctHeaderInitialized === 'true') return;

    header.dataset.ctHeaderInitialized = 'true';

    const stickyType =
      header.dataset.stickyType || 'none';

    if (stickyType === 'none') {
      return;
    }

    let previousScrollY = window.scrollY;
    let ticking = false;

    const updateHeader = () => {
      const currentScrollY = window.scrollY;

      header.classList.toggle(
        'is-scrolled',
        currentScrollY > 12
      );

      if (stickyType === 'on-scroll-up') {
        if (currentScrollY <= 12) {
          header.classList.remove('is-hidden');
        } else if (currentScrollY > previousScrollY + 4) {
          header.classList.add('is-hidden');
        } else if (currentScrollY < previousScrollY - 4) {
          header.classList.remove('is-hidden');
        }
      }

      if (stickyType === 'reduce-logo-size') {
        header.classList.toggle(
          'is-compact',
          currentScrollY > 50
        );
      }

      previousScrollY = currentScrollY;
      ticking = false;
    };

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(
        updateHeader
      );
    };

    window.addEventListener(
      'scroll',
      handleScroll,
      {
        passive: true
      }
    );

    header.ctHeaderCleanup = () => {
      window.removeEventListener(
        'scroll',
        handleScroll
      );
    };

    updateHeader();
  }

  function initAllCozyTreeHeaders(scope = document) {
    if (
      scope.matches &&
      scope.matches('[data-ct-header]')
    ) {
      initCozyTreeHeader(scope);
    }

    scope
      .querySelectorAll('[data-ct-header]')
      .forEach(initCozyTreeHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllCozyTreeHeaders();
      }
    );
  } else {
    initAllCozyTreeHeaders();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllCozyTreeHeaders(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const header =
        event.target.querySelector(
          '[data-ct-header]'
        );

      if (
        header &&
        typeof header.ctHeaderCleanup === 'function'
      ) {
        header.ctHeaderCleanup();
      }
    }
  );
})();